import {Component} from '@angular/core';
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  imports: [
    RouterOutlet
  ],
  styleUrls: ['./legal.component.scss']
})
export class LegalComponent {

}
